import React, { createContext, useContext, useEffect, useState } from "react";
import { supabase } from "../lib/supabase";
import { useAuth } from "./AuthContext";

interface AdminContextType {
  isSuperadmin: boolean;
  loading: boolean;
}

const AdminContext = createContext<AdminContextType>({
  isSuperadmin: false,
  loading: true,
});

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error("useAdmin must be used within an AdminProvider");
  }
  return context;
};

export const AdminProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { user } = useAuth();
  const [isSuperadmin, setIsSuperadmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAdmin = async () => {
      if (!user) {
        setIsSuperadmin(false);
        setLoading(false);
        return;
      }

      try {
        const { data, error } = await supabase.functions.invoke("admin-check");
        if (error) {
          console.error("admin-check error:", error);
          setIsSuperadmin(false);
        } else {
          setIsSuperadmin(!!(data as any)?.is_superadmin);
        }
      } catch (e) {
        console.error("admin-check exception:", e);
        setIsSuperadmin(false);
      } finally {
        setLoading(false);
      }
    };

    checkAdmin();
  }, [user]);

  return (
    <AdminContext.Provider value={{ isSuperadmin, loading }}>
      {children}
    </AdminContext.Provider>
  );
};
